import React, { useState } from 'react';
import { BookOpen, Calculator } from 'lucide-react';
import { blogPosts } from '../data/mockData';
import { BlogList } from './insights/BlogList';
import { Calculators } from './insights/Calculators';

const TABS = [
  { id: 'news', label: 'News & Blog', icon: BookOpen },
  // Temporarily hidden — content awaiting 2026 refresh
  // { id: 'market', label: 'Market Updates', icon: TrendingUp },
  // { id: 'events', label: 'Events & Webinars', icon: Users },
  { id: 'calculators', label: 'Financial Calculators', icon: Calculator }
];

const TabButton = ({ tab, active, onClick }) => {
  const Icon = tab.icon;
  return (
    <button
      onClick={onClick}
      data-testid={`insights-tab-${tab.id}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '1rem 1.5rem',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontWeight: 600,
        color: active ? 'var(--accent-gold-dark)' : 'var(--text-muted)',
        borderBottom: active ? '3px solid var(--accent-gold-dark)' : '3px solid transparent',
        transition: 'var(--transition-base)'
      }}
    >
      <Icon size={20} />
      {tab.label}
    </button>
  );
};

export const InsightsSection = () => {
  const [activeTab, setActiveTab] = useState('news');

  return (
    <section id="insights" className="section section-alt" data-testid="insights-section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="heading-1">Insights & Resources</h2>
          <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto', color: 'var(--text-secondary)' }}>
            Stay informed with our latest financial insights, market updates, educational resources, and powerful calculators.
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '3rem',
            borderBottom: '2px solid var(--gray-200)',
            flexWrap: 'wrap'
          }}
        >
          {TABS.map((tab) => (
            <TabButton key={tab.id} tab={tab} active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)} />
          ))}
        </div>

        {activeTab === 'news' && <BlogList posts={blogPosts} />}
        {activeTab === 'calculators' && <Calculators />}
      </div>
    </section>
  );
};
